import axios from 'axios';
import endpointNames from "../configs/serverUrls";

//url variable
const representativeUrl = endpointNames.representatives;

const aggregatorUrl = endpointNames.employer;
const representativeCategoriesUrl = endpointNames.representativeCategories;

// get User Token

//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

//add more representative
const addRepresentative = async (request) => {
    console.log("request: ", request);
    console.log("token: ", token);
    let response;

    const data = {
        "first_name": request.first_name,
        "last_name":request.last_name,
        "email":request.email,
        "contact_number":request.contact_number,
        "category_id": request.category_id,
        "aggregator_id":request.aggregator_id,
    };
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };

    await axios.post(representativeUrl,data, config)
        .then(res => {
            //if status 200 call save representative
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}


//get employer representativexit

// let employerId = JSON.parse(localStorage.getItem('employerId'));
const getAggregatorRepresentatives = async (employerId) => {
    let response;

    //create configuration with token
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
     //include the config in your request
    await axios.get(aggregatorUrl + '/representatives/' + parseInt(employerId), config)
        .then(res => {
            console.log("response: ", res)
            response = res.data.representatives;
            console.log("res: ", response)
        }).catch(err => {
            console.log(err);
            response = err;
        });
    // end

    return response;
}


const getAllCategories = async () => {
    let response;
    // start
     //gets user from localStorage
    //  console.log("user: ", user);
    //  console.log("token: ", token);

     //create configuration with token
     const config = {
         headers: {Authorization: `Bearer ${token}`}
     };
     //include the config in your request
     await axios.get(representativeCategoriesUrl, config)
         .then(res => {
             response = res.data.categories;
             console.log("RepCategories: ", response)
         }).catch(err => {
             console.log(err);
             response = err;
         });
    // end

    return response;
}



//get representative details
const getRepresentativeDetails = async(id) => {
    let response;

    //create configuration with token
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.get(representativeUrl + '/' + id, config)
        .then(res => {
            console.log(res);
            response = res.data;
        })
        .catch(err => {
            console.log(err)
            response = err;
        });
    return response;

}

//update representative
const updateRepresentative = async (id, request) => {
    let response;
    console.log("request: ", request);
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.put(representativeUrl + '/update/' + id, request, config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//delete representative
const deleteRepresentative = async (id) => {
    let response;
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.delete(representativeUrl + '/' + id, config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

export default {
    addRepresentative,getAggregatorRepresentatives,updateRepresentative,deleteRepresentative,getRepresentativeDetails,getAllCategories
}

